import { bool, object, string } from "prop-types";
import { observer } from "mobx-react";
import { getDateKey } from "@repo/structure";
import { useEstimateStructure, useEstimateEditorSettings } from "@tools";
import { getTimelineCellPeriods, getUtilizationWeightColor } from "@tools/EstimateEditor/utils";
import { TimelineScaffoldCell } from "./TimelineScaffoldCell";
import useStyle from "./TimelineCells.style";
import { TimelineUtilizationWeightTooltip } from "./TimelineUtilizationWeightTooltip";
import { NumericFormat } from "react-number-format";

export const TimelineUtilizationCell = observer(({ monthUtilization, bold, entityName }) => {
  const classes = useStyle();
  const structure = useEstimateStructure();
  const { isProposal } = useEstimateEditorSettings();

  if (!monthUtilization?.value) return <TimelineScaffoldCell month={monthUtilization} />;

  const {
    usedRoundDecimals,
    usedThousandSeparator,
  } = structure.settings;

  const expandedMonths = structure.settings.timelineExpandedMonths;
  const values = getTimelineCellPeriods(monthUtilization, expandedMonths);

  return (
    <>
      {values.map((value) => {
        return (
          <TimelineUtilizationWeightTooltip
            key={getDateKey(value.startDate)}
            weight={value.weight}
            period={value.type || "month"}
            hours={value.value || 0}
            possibleHours={value.optimal}
            entityName={entityName}
            disabled={isProposal}
          >
            <div className={classes.cell}>
              {
                !value.empty &&
                <NumericFormat
                  displayType="text"
                  value={value.value || 0}
                  thousandSeparator={usedThousandSeparator}
                  decimalSeparator="."
                  decimalScale={usedRoundDecimals}
                  valueIsNumericString
                  className={bold ? "font-bold" : undefined}
                  style={{ color: isProposal ? undefined : getUtilizationWeightColor(value.weight || 0) }}
                />
              }
            </div>
          </TimelineUtilizationWeightTooltip>
        );
      })}
    </>
  );
});

TimelineUtilizationCell.propTypes = {
  monthUtilization: object.isRequired,
  bold: bool,
  entityName: string,
};
